/* eslint-disable no-param-reassign */
import { dateToTime } from 'app/utils/utils';
import {
  ReleaseVersionSong,
  SoundCloudVersion,
  UpdateReleaseVersionSongPatchData,
  Version,
} from 'types/releases';
import { SelectedAudio } from 'app/components/Audio';

export const filterVersions = (
  versionList: Version[] | SoundCloudVersion[],
  versionGuid: string
): any => versionList.filter((item) => item.guid !== versionGuid);

export const getPopulatedVersion = (
  selectedAudioData: SelectedAudio,
  versionGuid: string
): SoundCloudVersion => ({
  isNew: true,
  guid: versionGuid,
  type: selectedAudioData.type,
  primaryAudioGuid: selectedAudioData.audioGuid,
  title: selectedAudioData.audioTitle,
  updated: dateToTime(new Date()),
  song: {
    guid: selectedAudioData.songGuid,
    songGuid: selectedAudioData.songGuid,
    overrides: {},
    updated: new Date().toISOString(),
    title: selectedAudioData.songTitle,
  },
});

export const getUpdateVersionCreditsMessage = ({
  isExcluded,
  success,
}: {
  isExcluded: boolean;
  success: boolean;
}) => {
  if (success) {
    return `Credit ${isExcluded ? 'removed' : 'added'} successfully`;
  }
  return `Failed to ${isExcluded ? 'remove' : 'add'} Credit`;
};

export const syncLabelVersionSongData = (
  data: UpdateReleaseVersionSongPatchData,
  overridesData: Partial<ReleaseVersionSong>
) => {
  const { genres, ...rest } = data;
  Object.keys(rest).forEach((key) => {
    if (rest[key] === null) {
      delete overridesData[key];
    }
    if (rest[key]) {
      overridesData[key] = rest[key];
    }
  });
  if (rest.location?.address === null) {
    delete overridesData.location?.address;
  }
  if (rest.location?.address) {
    overridesData.location = { address: rest.location.address };
  }

  if (!genres) {
    return;
  }
  if (!overridesData.genres) {
    overridesData.genres = [];
  }
  genres.forEach((item) => {
    if (item.op === 'ADD') {
      overridesData.genres?.push(item.genre);
    }
    if (item.op === 'REMOVE') {
      overridesData.genres = overridesData.genres?.filter(
        (genre) => genre !== item.genre
      );
    }
  });

  if (overridesData.genres.length === 0) {
    delete overridesData.genres;
  }
};
